import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PriceBox from '../price-box/PriceBox';
import LinkWrap from '../link-wrap/LinkWrap';
import Carousel from '../carousel/Carousel';
import CarouselSwipe from '../carousel/CarouselSwipe';
import LazyLoad from 'react-lazyload';
import ListingImage from '../listing-image/ListingImage';
import Interaction from '../interaction/Interaction';

class CarouselGroup extends Component {
  constructor (props) {
    super(props);

    this.carousel = this.carousel.bind(this);
    this.placeholderImage = this.placeholderImage.bind(this);
  }

  placeholderImage () {
    return (
      <div className="carousel" key="image-placeholder">
        <div className="carousel-item active">
          <ListingImage
            imgId=""
            ratio={ 1.69 }
            widths={ [256, 512] }
            defaultWidth={ 169 }
            defaultHeight={ 100 }
            alt="peerspace"
            sizes="50vw"
            style="cld-responsive cld-hidpi img-responsive lazyload"
            onPicLoad={ () => {} }
          />
        </div>
      </div>
    );
  }

  carousel () {
    const { swipeable } = this.props;
    const carousel = this.props.lazyLoad
      ? (
        <LazyLoad
          offset={50}
          placeholder={this.placeholderImage()}
          once
        >
          {swipeable ? <CarouselSwipe { ...this.props } /> : <Carousel { ...this.props } />}
        </LazyLoad>)
      : swipeable ? <CarouselSwipe { ...this.props } /> : <Carousel { ...this.props } />;

    return this.props.hidePhotos
      ? <div className="carousel-placeholder" />
      : carousel;
  }

  render () {
    const {
      listing: {
        hourly_price,
        currency
      },
      showInstaBook,
      swipeable
    } = this.props;

    return (
      <LinkWrap { ...this.props }>
        <div className="carousel-wrapper" style={swipeable ? { padding: '0' } : {}}>
          <Interaction { ...this.props } hideText />
          { this.carousel() }
          <PriceBox
            price={ parseInt(hourly_price, 10) }
            currency={ currency }
            showInstaBook={ showInstaBook }
          />
        </div>
      </LinkWrap>
    );
  }
}

CarouselGroup.propTypes = {
  lazyLoad: PropTypes.bool,
  hidePhotos: PropTypes.bool,
  showInstaBook: PropTypes.bool,
  listing: PropTypes.object,
  swipeable: PropTypes.bool
};

export default CarouselGroup;
